import { motion, AnimatePresence } from "framer-motion";
import { PaperPlaneTilt, FileZip, XCircle, X } from "@phosphor-icons/react";
import type { InvoiceLabels } from "./types";

interface Props {
  count: number;
  labels: InvoiceLabels;
  onSend: () => void;
  onDownload: () => void;
  onVoid: () => void;
  onClear: () => void;
}

export function InvoiceBulkActionBar({ count, labels, onSend, onDownload, onVoid, onClear }: Props) {
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
          role="region"
          aria-label="Bulk actions"
          className="fixed bottom-4 left-1/2 -translate-x-1/2 z-30 bg-biz-foreground text-biz-bg rounded-2xl biz-shadow-lg px-3 py-2 flex items-center gap-2 biz-motion-safe"
        >
          <span className="font-mono-num h-7 px-2.5 inline-flex items-center rounded-full bg-biz-primary text-biz-primary-foreground text-xs font-semibold">
            {count}
          </span>
          <span className="text-sm font-medium pr-1">{labels.bulk.selected}</span>

          <div className="h-5 w-px bg-biz-bg/20 mx-1" />

          <button
            type="button"
            onClick={onSend}
            className="h-9 px-3 inline-flex items-center gap-1.5 rounded-biz-btn bg-biz-bg/10 hover:bg-biz-bg/20 text-sm font-semibold biz-focus-ring"
          >
            <PaperPlaneTilt size={14} /> {labels.bulk.sendAll}
          </button>
          <button
            type="button"
            onClick={onDownload}
            className="h-9 px-3 inline-flex items-center gap-1.5 rounded-biz-btn bg-biz-bg/10 hover:bg-biz-bg/20 text-sm font-semibold biz-focus-ring"
          >
            <FileZip size={14} /> {labels.bulk.downloadZip}
          </button>
          <button
            type="button"
            onClick={onVoid}
            className="h-9 px-3 inline-flex items-center gap-1.5 rounded-biz-btn bg-biz-danger/80 hover:bg-biz-danger text-biz-danger-foreground text-sm font-semibold biz-focus-ring"
          >
            <XCircle size={14} /> {labels.bulk.voidAll}
          </button>

          <div className="h-5 w-px bg-biz-bg/20 mx-1" />

          <button
            type="button"
            onClick={onClear}
            aria-label={labels.bulk.clear}
            className="h-9 w-9 inline-flex items-center justify-center rounded-biz-btn hover:bg-biz-bg/10 biz-focus-ring"
          >
            <X size={16} weight="bold" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
